module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-73691c501f74d0fa031b23085e2992a1.png";